export const UNKNOWN_SECTION_NAME = 'unknown' as const;
